import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "@fontsource/cinzel/400.css";
import "@fontsource/cinzel/600.css";
import "@fontsource/cinzel/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/700.css";

const rootEl = document.getElementById("root")!;
const bootLoader = document.getElementById("app-boot-loader");

createRoot(rootEl).render(<App />);

// Fade out the pre-React boot loader once React has mounted
if (bootLoader) {
  requestAnimationFrame(() => {
    bootLoader.classList.add("fade-out");
    setTimeout(() => bootLoader.remove(), 400);
  });
}
